const siteOrigin = 'https://www.parentool.cn'

type ToolEventName =
  | 'tool_view'
  | 'tool_upload'
  | 'tool_submit'
  | 'tool_success'
  | 'tool_copy'
  | 'tool_download'

type ToolEventPayload = {
  tool_id: string
  tool_name: string
  tool_category: string
  action_type: string
}

declare global {
  interface Window {
    dataLayer?: unknown[]
    gtag?: (...args: unknown[]) => void
  }
}

export const gaMeasurementId = 'self-hosted'

const sendAnalyticsEvent = (payload: Record<string, string>) => {
  if (typeof window === 'undefined') return

  const body = JSON.stringify({
    pagePath: window.location.pathname,
    pageLocation: window.location.href,
    referrer: document.referrer || '',
    ...payload
  })

  if (navigator.sendBeacon) {
    const blob = new Blob([body], { type: 'application/json' })
    navigator.sendBeacon('/api/analytics/events', blob)
    return
  }

  if (typeof fetch !== 'function') return

  void fetch('/api/analytics/events', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body,
    keepalive: true
  }).catch(() => {
    // Analytics failures should never affect tool usage.
  })
}

export const sendPageView = (pathname: string) => {
  sendAnalyticsEvent({
    eventName: 'page_view',
    pagePath: pathname,
    pageLocation: pathname === '/' ? `${siteOrigin}/` : `${siteOrigin}${pathname}`
  })
}

export const sendToolEvent = (eventName: ToolEventName, payload: ToolEventPayload) => {
  sendAnalyticsEvent({
    eventName,
    toolId: payload.tool_id,
    toolName: payload.tool_name,
    toolCategory: payload.tool_category,
    actionType: payload.action_type
  })
}
